var map = {
	"./caseIH.svg": 37915,
	"./claas.svg": 59566,
	"./deutzFahr.svg": 9011,
	"./dllGroup.svg": 88399,
	"./efarmFinancing.svg": 40911,
	"./fendt.svg": 467,
	"./johnDeere.svg": 65649,
	"./kubota.svg": 62385,
	"./masseyFerguson.svg": 69778,
	"./newHolland.svg": 1617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72716;